import { Row, Col } from "reactstrap";
import { CustomTable } from "components";
import { myLessonRecordsTableColumn } from "../constants";

const StaffLessonRecords = ({ staff, isLoading }) => {
	return (
		<Row>
			<Col>
				<CustomTable
					data={staff?.lessonRecords}
					columns={myLessonRecordsTableColumn}
					defaultPageSize={10}
					title={`${staff?.username || ""}'s Lesson Records`}
					loading={isLoading}
					marginClass={null}
				/>
			</Col>
		</Row>
	);
};

export default StaffLessonRecords;
